import { useEffect, useState } from 'react';
import { Country } from '../models/country';
import { fetchCountries } from '../services/countries-service';
import { useClubContext } from '../context/ClubContext';

export const useCountries = () => {
    const [countries, setCountries] = useState<Country[] | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const { club } = useClubContext();

    useEffect(() => {
        if (!club?.showCountrySelect) return;

        setIsLoading(true);
        fetchCountries()
            .then((response: Country[]) => {
                if (response) setCountries(response);
            })
            .catch((e) => setError(e.message))
            .finally(() => setIsLoading(false));
    }, [club?.showCountrySelect]);

    return { countries, isLoading, error };
}
